import React from 'react'
import './NoPermissions.css'
import image from '../../assets/images/block.png'

function NoPermissions({isHeight}) {
    return (
        <main>
            <div className="margin_main no-per" style={isHeight ? {height: "70vh"}: {height: "80vh"}}>
                <img src={image} />
                <span>You have no permission</span>
            </div>
        </main>
    )
}

export default NoPermissions